import { memo } from 'react'
import EmptyTableContent from '../error/EmptyTableContent'
import CustomerTbody from './table-body/CustomerTbody'

function CustomersTable({ customers, customerTypeListItem, openTab, editCustomer }) {
  return (
    <div className="relative rounded-2xl border border-light-gray max-h-[450px] dark:border-gray-700 overflow-auto scroll-smooth">
      {(customerTypeListItem && customerTypeListItem[openTab]?.length > 0) ||
      (openTab === 0 && customers.length > 0) ? (
        <table className="w-full text-sm text-right relative whitespace-nowrap">
          <thead className="text-md bg-light-blue dark:bg-slate-800 sticky top-0 w-full">
            <tr className={'border-b border-b-light-gray dark:border-b-gray-700'}>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                ردیف
              </th>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                جنسیت
              </th>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                نام و نام خانوادگی
              </th>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                دسته بندی
              </th>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                شماره همراه
              </th>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                عملیات
              </th>
            </tr>
          </thead>

          <tbody className={'text-md bg-light-blue dark:bg-slate-800'}>
            {openTab === 0
              ? customers.map((customer, index) => (
                  <CustomerTbody
                    key={customer.id}
                    index={index}
                    customer={customer}
                    editCustomer={editCustomer}
                  />
                ))
              : customerTypeListItem[openTab].map((customer, index) => (
                  <CustomerTbody
                    key={customer.id}
                    index={index}
                    customer={customer}
                    editCustomer={editCustomer}
                  />
                ))}
          </tbody>
        </table>
      ) : (
        <EmptyTableContent text={'کاربری ثبت نشده است.'} />
      )}
    </div>
  )
}

export default memo(CustomersTable)
